import { injectAll, singleton } from 'tsyringe';
import { SubGameHandler, kNameOfSubGameHandler } from './sub-game-handler';

// -----------------------------------------------------------------------------
// Routes a parent gameId to its registered SubGameHandler. Handlers are
// discovered via @injectAll on kNameOfSubGameHandler and bucketed by the
// gameId each handler exposes.
@singleton()
export class SubGameHandlerRegistry {
  private readonly handlersByGameId: Map<number, SubGameHandler>;

  // ---------------------------------------------------------------------------
  public constructor(
    @injectAll(kNameOfSubGameHandler)
    handlers: SubGameHandler[],
  ) {
    this.handlersByGameId = new Map<number, SubGameHandler>();
    for (const handler of handlers) {
      this.handlersByGameId.set(handler.gameId, handler);
    }
  }

  // ---------------------------------------------------------------------------
  public get(gameId: number): SubGameHandler | undefined {
    return this.handlersByGameId.get(gameId);
  }
}
